"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _productHelper = require("../../../../helpers/productHelper");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellBalancesComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-balances');
var BuySellBalancesComponent = function BuySellBalancesComponent(props) {
  var product1 = props.product1,
    product2 = props.product2,
    customClass = props.customClass;
  var product1Label = "".concat(customClass === 'compacted' && product1 !== null && product1 !== void 0 && product1.Product ? product1.Product : '', " ").concat((product1 === null || product1 === void 0 ? void 0 : product1.ProductFullName) || '', ":");
  var product2Label = "".concat(customClass === 'compacted' && product2 !== null && product2 !== void 0 && product2.Product ? product2.Product : '', " ").concat((product2 === null || product2 === void 0 ? void 0 : product2.ProductFullName) || '', ":");
  var product1Text = (0, _productHelper.getBalanceWithProductSymbol)(product1 === null || product1 === void 0 ? void 0 : product1.Product, (product1 === null || product1 === void 0 ? void 0 : product1.AvailableBalance) || 0);
  var product2Text = (0, _productHelper.getBalanceWithProductSymbol)(product2 === null || product2 === void 0 ? void 0 : product2.Product, (product2 === null || product2 === void 0 ? void 0 : product2.AvailableBalance) || 0);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass || '', " ").concat(classes())
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass || '', " ").concat(classes('content'))
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    customClass: "".concat(customClass || '', " ").concat(classes()),
    label: product1Label,
    text: product1Text
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    customClass: "".concat(customClass || '', " ").concat(classes()),
    label: product2Label,
    text: product2Text
  })));
};
BuySellBalancesComponent.propTypes = {
  customClass: _propTypes["default"].string,
  product1: _propTypes["default"].object,
  product2: _propTypes["default"].object
};
var _default = exports["default"] = BuySellBalancesComponent;